let counter = 0;

/** Monotonic, collision-free within a session; short enough to read while debugging. */
export function createId(prefix: string): string {
  counter += 1;
  return `${prefix}_${counter.toString(36)}${Math.random().toString(36).slice(2, 6)}`;
}
